import {
    apiRequest,
    agamaDetail,
    agamaUpdate
} from "../../../../../services/adapters/kepegawaian/agamaService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", agamaDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", agamaUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository